// CHATSTATE
export const CHAT_CONNECTED = 'CHAT_CONNECTED';
export const CHAT_CONNECTION_FAILED = 'CHAT_CONNECTION_FAILED';
export const CHAT_DISCONNECTED = 'CHAT_DISCONNECTED';
export const UPDATE_PAGINATION = 'UPDATE_PAGINATION';
export const CHAT_BEGIN_GET_MESSAGES = 'CHAT_BEGIN_GET_MESSAGES';

// MESSAGES
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE';
export const MARK_MESSAGE = 'MARK_MESSAGE';
export const RECEIVE_MESSAGES = 'RECEIVE_MESSAGES';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const TRAIN_MESSAGE = 'TRAIN_MESSAGE';
export const USER_TYPING_MESSSAGE = 'USER_TYPING_MESSSAGE';
export const USER_STOP_TYPING_MESSSAGE = 'USER_STOP_TYPING_MESSSAGE';
export const RECEIVE_TEXT_SUGGESTIONS_MESSAGE = 'RECEIVE_TEXT_SUGGESTIONS_MESSAGE';
export const CHAT_GET_STARRED_MESSAGES_BEGIN = 'CHAT_GET_STARRED_MESSAGES_BEGIN';
export const CHAT_GET_STARRED_MESSAGES_SUCCESS = 'CHAT_GET_STARRED_MESSAGES_SUCCESS';
export const CHAT_VIEW_STARRED_MESSAGES = 'CHAT_VIEW_STARRED_MESSAGES';
export const CHAT_DELETE_ALL_BOOKMARKS = 'CHAT_DELETE_ALL_BOOKMARKS';
export const UPDATE_STARRED_PAGINATION = 'UPDATE_STARRED_PAGINATION';
export const CHAT_GET_STARRED_MESSAGES_FAILURE = 'CHAT_GET_STARRED_MESSAGES_FAILURE';
export const CHAT_GET_STARRED_MESSAGES_DISMISS_ERROR = 'CHAT_GET_STARRED_MESSAGES_DISMISS_ERROR';
export const CHAT_CREATE_CHAT_BOOKMARK_BEGIN = 'CHAT_CREATE_CHAT_BOOKMARK_BEGIN';
export const CHAT_CREATE_CHAT_BOOKMARK_SUCCESS = 'CHAT_CREATE_CHAT_BOOKMARK_SUCCESS';
export const CHAT_CREATE_CHAT_BOOKMARK_FAILURE = 'CHAT_CREATE_CHAT_BOOKMARK_FAILURE';
export const CHAT_CREATE_CHAT_BOOKMARK_DISMISS_ERROR = 'CHAT_CREATE_CHAT_BOOKMARK_DISMISS_ERROR';
export const CHAT_REMOVE_CHAT_BOOKMARK_BEGIN = 'CHAT_REMOVE_CHAT_BOOKMARK_BEGIN';
export const CHAT_REMOVE_CHAT_BOOKMARK_SUCCESS = 'CHAT_REMOVE_CHAT_BOOKMARK_SUCCESS';
export const CHAT_REMOVE_CHAT_BOOKMARK_FAILURE = 'CHAT_REMOVE_CHAT_BOOKMARK_FAILURE';
export const CHAT_REMOVE_CHAT_BOOKMARK_DISMISS_ERROR = 'CHAT_REMOVE_CHAT_BOOKMARK_DISMISS_ERROR';
export const CHAT_REMOVE_ALL_BOOKMARKS_BEGIN = 'CHAT_REMOVE_ALL_BOOKMARKS_BEGIN';
export const CHAT_REMOVE_ALL_BOOKMARKS_SUCCESS = 'CHAT_REMOVE_ALL_BOOKMARKS_SUCCESS';
export const CHAT_REMOVE_ALL_BOOKMARKS_FAILURE = 'CHAT_REMOVE_ALL_BOOKMARKS_FAILURE';
export const CHAT_REMOVE_ALL_BOOKMARKS_DISMISS_ERROR = 'CHAT_REMOVE_ALL_BOOKMARKS_DISMISS_ERROR';
export const CHAT_MARK_CONV_REPLIED_BEGIN = 'CHAT_MARK_CONV_REPLIED_BEGIN';
export const CHAT_MARK_CONV_REPLIED_SUCCESS = 'CHAT_MARK_CONV_REPLIED_SUCCESS';
export const CHAT_MARK_CONV_REPLIED_FAILURE = 'CHAT_MARK_CONV_REPLIED_FAILURE';
export const CHAT_MARK_CONV_REPLIED_DISMISS_ERROR = 'CHAT_MARK_CONV_REPLIED_DISMISS_ERROR';
export const CHAT_UNDO_MARK_REPLIED_BEGIN = 'CHAT_UNDO_MARK_REPLIED_BEGIN';
export const CHAT_UNDO_MARK_REPLIED_SUCCESS = 'CHAT_UNDO_MARK_REPLIED_SUCCESS';
export const CHAT_UNDO_MARK_REPLIED_FAILURE = 'CHAT_UNDO_MARK_REPLIED_FAILURE';
export const CHAT_UNDO_MARK_REPLIED_DISMISS_ERROR = 'CHAT_UNDO_MARK_REPLIED_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/chat/redux/constants.js